import { Outlet, Navigate, useLocation } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
import "assets/custom.styles.css";
import "assets/main.c8501cfb.css"

import { ToastContainer } from "react-toastify";

import { useAuthContext } from "../../front/contexts";
import FrontHeader from "./header"



// ==============================|| MINIMAL LAYOUT ||============================== //

const FrontLayout = () => {
  const { token } = useAuthContext();
  const location = useLocation();
  //console.log(location,token)
   return (
   <>
   <div className="frontClass">
    <ToastContainer hideProgressBar theme="dark" autoClose={2000} />
    {
         
            location?.pathname?.match('/signup') ||location?.pathname?.match('/login')  ||location?.pathname?.match('/forgot-password') ? ( <Outlet /> ) :
            ( <FrontHeader /> )
          
        }
        </div>
  </>
   )
        
  
  }

export default FrontLayout;
